module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.aa66d0e.eot";


//////////////////
// WEBPACK FOOTER
// ./static/fontawesome-5.10.2/webfonts/fa-regular-400.eot
// module id = 268
// module chunks = 1